export const generateHashMapObjectFromArray = (
  items: any[],
  defaultValue: any,
) => {
  return items.reduce((resultObject, i) => {
    resultObject[i] = defaultValue
    return resultObject
  }, {})
}
